// Bio-Viber is only meant to be used from Schema Link: users are sent here
// whenever they'd otherwise land on Bio-Viber's own homepage -- on an error,
// via DisplayGraph's Exit, or when opening Bio-Viber with no SK data waiting.
export const SCHEMALINK_URL = "https://schemalink.anacleto.di.unimi.it";
